import { captureSentryError } from '@vrplatform/data';
import { useEffect } from 'react';
import { useLocation, useRouteError } from 'react-router';
import { ErrorFallback } from '../components';

// React Router catches render errors below a route and shows its own
// "Unexpected Application Error!" screen, so they never reach Sentry or our
// ErrorBoundary. This route error element reports them and shows our view.
export function RouteErrorElement() {
  const error = useRouteError();
  const { pathname } = useLocation();

  useEffect(() => {
    captureSentryError(error, {
      tags: { source: 'react-router-error-element' },
      extra: { pathname },
    });
  }, [error, pathname]);

  return <ErrorFallback error={error} />;
}
